import {Component, inject, Input} from '@angular/core';
import {NgIf} from "@angular/common";
import {BaseComponent} from "@wms/components";
import {BsDropdownDirective} from "ngx-bootstrap/dropdown";
import {ProjectUpdatesService} from "@wms/app/project-updates/services/project-updates/project-updates.service";

@Component({
  selector: 'wms-project-updates-notification',
  standalone: true,
  imports: [
    NgIf
  ],
  templateUrl: './project-updates-notification.component.html',
  styleUrls: ['./project-update-notification.component.less'],
})
export class ProjectUpdatesNotificationComponent extends BaseComponent {
  @Input() dropdown: BsDropdownDirective;
  projectUpdatesService = inject(ProjectUpdatesService);
}
